import {base} from "../base";

async function addNew(data) {
  return base.post("catalogs/inventories", data);
}

async function update(data) {
  return base.put("catalogs/inventories", data);
}

async function getList(data) {
  return base.get("catalogs/inventories", data);
}

async function getListGoodsIssue(data) {
  return base.get("services/goods-issue", data);
}

async function createGoodsIssue(data) {
  return base.post("services/goods-issue", data);
}

async function updateGoodsIssue(data) {
  return base.put("services/goods-issue", data);
}

async function getListGoodsReceipt(data) {
  return base.get("services/goods-receipt", data);
}

async function createGoodsReceipt(data) {
  return base.post("services/goods-receipt", data);
}

async function createListGoodsReceiptRevokeShipper(data) {
  return base.post("stokers/services/shipper/revoke", data);
}

async function updateGoodsReceipt(data) {
  return base.put("services/goods-receipt", data);
}

async function getListStockTake(data) {
  return base.get("services/stock-take", data);
}

async function createStockTake(data) {
  return base.post("services/stock-take", data);
}

async function cancelStockTake(data) {
  return base.put("services/stock-take", data);
}

async function checkInventory(data) {
  return base.post("reports/inventory/available", data);
}

async function importOldDebtCustomer(data) {
  return base.put("catalogs/customers/import", data);
}

async function reportInventoryChangeUnit(param){
  return base.get("reports/inventory/change-unit", param);
}

export const inventoryService = {
  addNew,
  update,
  getList,
  getListGoodsIssue,
  createGoodsIssue,
  updateGoodsIssue,
  getListGoodsReceipt,
  createGoodsReceipt,
  createListGoodsReceiptRevokeShipper,
  updateGoodsReceipt,
  getListStockTake,
  createStockTake,
  cancelStockTake,
  checkInventory,
  importOldDebtCustomer,
  reportInventoryChangeUnit
};
